import React from 'react';

const LoginFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="mt-8 text-center space-y-4">
      {/* Help Links */}
      <div className="flex justify-center space-x-6 text-sm">
        <button className="text-text-secondary hover:text-primary transition-micro">
          Help Center
        </button>
        <button className="text-text-secondary hover:text-primary transition-micro">
          Contact Support
        </button>
        <button className="text-text-secondary hover:text-primary transition-micro">
          Privacy Policy
        </button>
      </div>

      {/* Copyright */}
      <div className="text-xs text-text-muted">
        © {currentYear} ServiceReviewAI. All rights reserved.
      </div>

      {/* Version Info */}
      <div className="text-xs text-text-muted">
        Version 2.1.0
      </div>
    </div>
  );
};

export default LoginFooter;